(function () {
  'use strict';

  var overlay     = document.getElementById('variantPopupOverlay');
  var closeBtn    = document.getElementById('variantPopupClose');
  var imgEl       = document.getElementById('variantPopupImg');
  var titleEl     = document.getElementById('variantPopupTitle');
  var priceEl     = document.getElementById('variantPopupPrice');
  var optNameEl   = document.getElementById('variantPopupOptionName');
  var optionsGrid = document.getElementById('variantOptionsGrid');
  var atcBtn      = document.getElementById('variantPopupATC');
  var successEl   = document.getElementById('variantPopupSuccess');

  if (!overlay) return; // safety check

  var selectedVariantId = null;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return 'Rs. ' + amount;
  }

  function showLoader() {
    optionsGrid.innerHTML =
      '<div class="variant-popup-loader">' +
        '<div class="variant-popup-loader-dot"></div>' +
        '<div class="variant-popup-loader-dot"></div>' +
        '<div class="variant-popup-loader-dot"></div>' +
      '</div>';
  }

  function resetPopup() {
    selectedVariantId = null;
    showLoader();
    atcBtn.disabled = true;
    atcBtn.textContent = 'Select an option';
    atcBtn.classList.remove('loading');
    successEl.classList.remove('show');
    imgEl.src = '';
    titleEl.textContent = '';
    priceEl.textContent = '';
    optNameEl.textContent = 'Option';
  }

  function openPopup(productHandle, fallbackImg) {
    resetPopup();
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';

    if (fallbackImg) {
      imgEl.src = fallbackImg;
    }

    fetch('/products/' + productHandle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('Network error');
        return r.json();
      })
      .then(function (product) {

        if (product.images && product.images.length > 0) {
          imgEl.src = product.images[0];
          imgEl.alt = product.title;
        }

        titleEl.textContent = product.title;

        // Single default variant → add directly without popup
        if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
          closePopup();
          addToCartAjax(product.variants[0].id, 1).then(refreshCartCount);
          return;
        }

        var prices = product.variants.map(function (v) { return v.price; });
        priceEl.textContent = formatMoney(Math.min.apply(null, prices));

        var optionName = (product.options && product.options[0] && typeof product.options[0] === 'string') ? product.options[0] : (product.options && product.options[0] && product.options[0].name) ? product.options[0].name : 'Option';
        optNameEl.textContent = optionName;

        optionsGrid.innerHTML = '';

        product.variants.forEach(function (variant) {
          var btn = document.createElement('button');
          btn.className = 'variant-option-btn';
          btn.textContent = variant.title;
          btn.dataset.variantId = variant.id;

          if (!variant.available) {
            btn.classList.add('unavailable');
            btn.disabled = true;
            btn.title = 'Out of stock';
          }

          btn.addEventListener('click', function () {
            if (!variant.available) return;

            optionsGrid.querySelectorAll('.variant-option-btn').forEach(function (b) {
              b.classList.remove('selected');
            });

            btn.classList.add('selected');
            selectedVariantId = variant.id;

            // Animate price update
            priceEl.classList.add('price-updating');
            setTimeout(function () { priceEl.classList.remove('price-updating'); }, 250);
            priceEl.textContent = formatMoney(variant.price);

            atcBtn.disabled = false;
            atcBtn.textContent = 'Add to Cart';
            successEl.classList.remove('show');
          });

          optionsGrid.appendChild(btn);
        });

      })
      .catch(function (err) {
        optionsGrid.innerHTML = '<span style="color:#c0392b;font-size:13px;">Failed to load options. Please visit the product page.</span>';
        console.error('Variant popup fetch error:', err);
      });
  }

  function closePopup() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    selectedVariantId = null;
  }

  // ATC button inside popup - use theme's own Shopify.addItem so miniCart updates properly
  atcBtn.addEventListener('click', function () {
    if (!selectedVariantId) return;

    atcBtn.classList.add('loading');
    atcBtn.textContent = 'Adding...';

    var varId = parseInt(selectedVariantId);

    // Use theme's Shopify.addItem if available - it handles miniCart update automatically
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.addItem === 'function') {
      window.Shopify.addItem(varId, 1, function(item) {
        // Theme's miniCart update - same as theme.js does
        if (window.theme && window.theme.miniCart) {
          window.theme.miniCart.generateCart();
          window.theme.miniCart.updateElements();
        }
        // Update cart count
        document.querySelectorAll('.js-cart-count, .site-header__cart-indicator').forEach(function(el) {
          el.textContent = parseInt(el.textContent || '0') + 1;
        });
        atcBtn.classList.remove('loading');
        atcBtn.textContent = 'Added to Cart!';
        successEl.classList.add('show');
        setTimeout(closePopup, 1500);
      });
    } else {
      // Fallback: fetch cart/add.js directly
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: varId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        if (item.status && item.status >= 400) throw new Error(item.description || 'Error');
        // Fetch updated cart count
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            document.querySelectorAll('.js-cart-count, .site-header__cart-indicator, [data-cart-count], .cart-count, #CartCount').forEach(function(el) {
              el.textContent = cart.item_count;
            });
            if (window.theme && window.theme.miniCart) {
              window.theme.miniCart.generateCart();
              window.theme.miniCart.updateElements();
            }
          });
        atcBtn.classList.remove('loading');
        atcBtn.textContent = 'Added to Cart!';
        successEl.classList.add('show');
        setTimeout(closePopup, 1500);
      })
      .catch(function(err) {
        atcBtn.classList.remove('loading');
        atcBtn.textContent = 'Error — please try again';
        atcBtn.disabled = false;
        console.error('ATC error:', err);
      });
    }
  });

  // Close triggers
  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('active')) closePopup();
  });

  // Intercept Add to Cart clicks globally
  // useCapture=true means this fires BEFORE jQuery's delegated handlers
  document.addEventListener('click', function (e) {
    var target = e.target;

    // Product page pe popup nahi chahiye
    var isProductPage = window.location.pathname.indexOf('/products/') !== -1;
    if (isProductPage) return;

    // Skip cart drawer/page buttons
    if (target.closest('.cart-drawer, .cart__items, .cart-form, #cart-drawer, .CartDrawer, .mini-cart, .side-cart, [data-quantity-minus], [data-quantity-plus]')) return;

    // Only intercept .js-grid-cart clicks (theme's ATC button)
    var atcEl = target.closest('.js-grid-cart');
    if (!atcEl) return;

    // Skip if disabled (sold out)
    if (atcEl.classList.contains('disabled')) return;

    // Get product handle - from data-handle on button itself OR from nearby product link
    var productHandle = atcEl.dataset.handle || atcEl.dataset.productHandle || null;
    var fallbackImg = null;

    // Walk up DOM to find product card and extract handle from link
    if (!productHandle) {
      var parent = atcEl.parentElement;
      for (var j = 0; j < 12; j++) {
        if (!parent) break;
        // Grab fallback image
        if (!fallbackImg) {
          var pImg = parent.querySelector('img.first-image, img.lazyload, img');
          if (pImg && pImg.src && pImg.src.indexOf('no-image') === -1) {
            fallbackImg = pImg.src;
          }
        }
        // Find product link
        var pLink = parent.querySelector('a.product-card__name, a.product-card__image, a[href*="/products/"]');
        if (pLink) {
          var m = pLink.href.match(/\/products\/([^?#\/]+)/);
          if (m) { productHandle = m[1]; break; }
        }
        parent = parent.parentElement;
      }
    }

    if (productHandle) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openPopup(productHandle, fallbackImg);
    }

  }, true);

})();
